import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import { useClearBrowserCache } from 'react-clear-browser-cache';
import { Routing } from "./Routes";

export default function App({ store, basename }) {

  useClearBrowserCache();

  return (
    <Provider store={store}>
      <BrowserRouter basename={basename}>
        {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
        <LastLocationProvider>
          {/* Render routes with provided `Layout`. */}
               <Routing />
        </LastLocationProvider>
      </BrowserRouter>
    </Provider>
  );
}
